(function () {
  const LEGACY_TICKER_PATTERN = /^\d+\s+people\s+viewing\s+this\s+product(?:\s+right\s+now)?$/i;

  function removeLegacyViewingTickers(root = document) {
    const productDetails = root.querySelectorAll?.('.product-details') || [];

    productDetails.forEach((details) => {
      details.querySelectorAll('p, div, span, aside').forEach((candidate) => {
        if (candidate.closest('[data-tbh-viewing-ticker]')) return;

        const text = candidate.textContent.replace(/\s+/g, ' ').trim();
        if (!LEGACY_TICKER_PATTERN.test(text)) return;

        candidate.setAttribute('data-tbh-legacy-viewing-ticker', '');
        candidate.hidden = true;
      });
    });
  }

  removeLegacyViewingTickers();

  const productDetails = document.querySelector('.product-details');
  if (productDetails) {
    const observer = new MutationObserver(() => removeLegacyViewingTickers());
    observer.observe(productDetails, { childList: true, subtree: true });
  }

  const tickers = document.querySelectorAll('[data-tbh-viewing-ticker]');
  if (!tickers.length) return;

  const BUCKET_MS = 5 * 60 * 1000;

  function hashString(value) {
    let hash = 0;
    for (let i = 0; i < value.length; i += 1) {
      hash = (hash * 31 + value.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
  }

  function countFor(handle, bucket) {
    // Keep it below 20, but still hype-friendly.
    const base = hashString(`${handle}:${bucket}`);
    return 8 + (base % 12); // 8..19
  }

  tickers.forEach((ticker) => {
    const countEl = ticker.querySelector('[data-tbh-viewing-count]');
    const handle = ticker.getAttribute('data-product-handle') || 'product';
    if (!(countEl instanceof HTMLElement)) return;

    function renderCount() {
      const bucket = Math.floor(Date.now() / BUCKET_MS);
      const count = countFor(handle, bucket);
      countEl.textContent = String(count);
    }

    renderCount();
    window.setInterval(renderCount, BUCKET_MS);
  });
})();
